import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "at-share-dialog"
};
const _hoisted_2 = {
  class: "p-4 bg-white absolute right-0 top-0 cursor-pointer"
};
const _hoisted_3 = {
  class: "flex flex-col"
};
const _hoisted_4 = {
  class: "p-4 flex items-center justify-start"
};
const _hoisted_5 = {
  class: "p-2 flex flex-row"
};
const _hoisted_6 = {
  class: "p-4"
};
const _hoisted_7 = {
  key: 0,
  class: "at-select-some-user"
};
const _hoisted_8 = {
  key: 1,
  class: "at-select-some-user"
};
const _hoisted_9 = {
  key: 2,
  class: "at-select-some-user"
};
const _hoisted_10 = {
  class: "p-4"
};
import { reactive, ref, computed, watchEffect } from "vue";
import LlCheckbox from "@/components/LlCheckbox.vue";
import LlIcon from "@/components/LlIcon.vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { useEmbeddedReportStore } from "./useEmbeddedReportStore.js";
import { useShareDashboardStore } from "./useShareDashboardStore.js";
export default {
  __name: 'ShareDashboard',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    leftNavBarState: {
      type: Object,
      required: false
    }
  },
  emits: ["closeDeleteDialog"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const embeddedReportStore = useEmbeddedReportStore();
    const shareDashboardStore = useShareDashboardStore();
    shareDashboardStore.alerts = props.alerts;
    const shareDashboardState = reactive({
      dialog: true,
      loading: false,
      dashboard: null,
      description: {
        en: ""
      }
    });
    const ownedUsers = ref([]);
    const selectedUsers = ref([]);
    const checkedAllUsers = computed(() => selectedUsers.value.length === ownedUsers.value.length);
    const checkedSomeUsers = computed(() => selectedUsers.value.length > 0);
    const loadShareableDashboards = async () => {
      shareDashboardState.loading = true;
      await shareDashboardStore.listShareableDashboards();
      shareDashboardState.dashboard = shareDashboardStore.getShareableDashboardById(props.leftNavBarState.shareDashboardId);
      shareDashboardState.description.en = shareDashboardState.dashboard?.description;
      const usersFromDashboard = shareDashboardStore.getUsersFromShareableDashboard(props.leftNavBarState.shareDashboardId) || [];
      selectedUsers.value = usersFromDashboard.map(user => user.sharedWith ? user.id : null).filter(id => id !== null);
      shareDashboardState.loading = false;
      if (usersFromDashboard.length > 0) {
        ownedUsers.value = [...usersFromDashboard];
      } else {
        ownedUsers.value = [];
      }
    };
    watchEffect(() => {
      if (props.leftNavBarState.shareDashboardId) {
        loadShareableDashboards();
      }
    });
    const toggle = () => {
      const selectAll = !checkedAllUsers.value;
      selectedUsers.value = selectAll ? ownedUsers.value.map(({
        id
      }) => id) : [];
      const setShared = users => users.forEach(u => u.sharedWith = selectAll);
      setShared(ownedUsers.value);
      shareDashboardState.dashboard?.users && setShared(shareDashboardState.dashboard.users);
      checkedAllUsers.value = selectAll;
    };
    const shareDashboard = async () => {
      shareDashboardState.dashboard.users = shareDashboardState.dashboard.users.map(user => {
        if (selectedUsers.value.includes(user.id)) {
          user.sharedWith = true;
        } else {
          user.sharedWith = false;
        }
        return user;
      });
      shareDashboardState.dashboard.description = shareDashboardState.description;
      embeddedReportStore.shareDashboardDialog = false;
      await shareDashboardStore.shareDashboard(shareDashboardState.dashboard);
    };
    const emit = __emit;
    const closeShareDialog = () => {
      selectedUsers.value = [];
      ownedUsers.value = [];
      shareDashboardState.description.en = "";
      embeddedReportStore.shareDashboardDialog = false;
      props.leftNavBarState.shareDashboardId = undefined;
      emit("closeDeleteDialog");
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_select = _resolveComponent("v-select");
      const _component_v_textarea = _resolveComponent("v-textarea");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_row = _resolveComponent("v-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_dialog, {
          "onClick:outside": closeShareDialog,
          modelValue: _unref(embeddedReportStore).shareDashboardDialog,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(embeddedReportStore).shareDashboardDialog = $event),
          scrollable: "",
          width: "700",
          height: "620"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_v_icon, {
              onClick: closeShareDialog
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("mdi-close", -1)]))]),
              _: 1
            })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_v_icon, _mergeProps(props, {
              class: "ml-3",
              size: "40"
            }), {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("mdi-share-variant-outline", -1)]))]),
              _: 1
            }, 16), _createVNode(_component_v_card_title, {
              class: "text-h2 text-md-h5 text-lg-h4 font-extrabold at-share-report"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("Share Report", -1)]))]),
              _: 1
            })]), _createElementVNode("div", _hoisted_5, [_createVNode(LlIcon, {
              icon: "mdi-alert",
              class: "ml-6 p-2 mt-2",
              color: "error",
              size: "24"
            }), _cache[6] || (_cache[6] = _createElementVNode("p", {
              class: "ml-1 font-normal p-2"
            }, " Reports can be shared with users who would not have access to the underlying data in any other areas of LeanLaw ", -1))])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_v_select, {
              class: "at-select-users",
              modelValue: selectedUsers.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedUsers.value = $event),
              items: ownedUsers.value,
              "item-title": "label",
              "item-value": "id",
              label: "Select Users",
              multiple: "",
              variant: "outlined",
              color: "light-gray"
            }, {
              selection: _withCtx(({
                item,
                index
              }) => [selectedUsers.value.length <= 3 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.raw.label), 1)) : _createCommentVNode("", true), selectedUsers.value.length > 3 && index < 2 ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.raw.label), 1)) : _createCommentVNode("", true), selectedUsers.value.length > 3 && index === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_9, ",...")) : _createCommentVNode("", true)]),
              "prepend-item": _withCtx(() => [shareDashboardState.loading ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                class: "flex items-center justify-center"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_progress_circular, {
                  size: 70,
                  width: 7,
                  color: "success",
                  indeterminate: ""
                })]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_v_list_item, {
                key: 1,
                title: "Select All",
                onClick: toggle
              }, {
                prepend: _withCtx(() => [_createVNode(LlCheckbox, {
                  class: "at-select-all",
                  "aria-label": "Select all users",
                  indeterminate: checkedSomeUsers.value && !checkedAllUsers.value,
                  "model-value": checkedSomeUsers.value
                }, null, 8, ["indeterminate", "model-value"])]),
                _: 1
              }))]),
              _: 1
            }, 8, ["modelValue", "items"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_v_textarea, {
              clearable: "",
              modelValue: shareDashboardState.description.en,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => shareDashboardState.description.en = $event),
              label: "Description",
              variant: "outlined",
              counter: 400,
              maxlength: 400
            }, null, 8, ["modelValue"])]), _createVNode(_component_v_card_actions, {
              class: "pa-8"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
                variant: "tonal",
                onClick: closeShareDialog
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Close ", -1)]))]),
                _: 1
              }), _createVNode(LlSecondaryButton, {
                color: "primary",
                onClick: shareDashboard,
                class: "at-confirm-share",
                disabled: shareDashboardState.description?.en?.length > 400
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Share ", -1)]))]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]);
    };
  }
};